
import axios from "axios";
import TokenService from "./tokenlocalstorage.service";
import notificationService from "services/notification.service";
import authService from "services/auth.service";

import oauth from "./axiosBaseAuthClient";

const axiosClient = axios.create();

var test = false;

axiosClient.defaults.baseURL = process.env.REACT_APP_ENTERPRISE_IP_ADDRESS_PRICING;
// axiosClient.defaults.baseURL = 'http://34.219.48.250:8085/';

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

//All request will wait 2 seconds before timeout
// axiosClient.defaults.timeout = 2000;

axiosClient.defaults.withCredentials = false;

axiosClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    oauth.refreshToken(false);
    if (token && config.url !== "bss/svc/login") {
      config.headers["Authorization"] = "Bearer " + token; // for Spring Boot back-end
    }

    if (token && config.url === "bss/refreshToken") {
      // config.headers["Authorization"] =
      //   "Bearer " + TokenService.getLocalRefreshToken(); // for Spring Boot back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (res) => {
    notificationService.showSuccessResponseNotification(res.config.url);
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    notificationService.showErrorResponseNotification(originalConfig.url);
    //check refresh token is valid or not

    if (
      originalConfig.url !== "/bss/svc/login" &&
      originalConfig.url !== "/bss/refreshToken" &&
      err.response
    ) {
      // Access Token was expired
      if (
        err.response.status === 0 ||
        err.response.status === 401
        //&& !originalConfig._retry
      ) {
        // originalConfig._retry = true;

        try {
          await oauth.refreshToken(true);
          return axiosClient(originalConfig);
        } catch (_error) {
          if (_error.response.status === 400) {
            authService.logout();
            window.location.href = "/";
          }
          return Promise.reject(_error);
        }
      }
    } else if (originalConfig.url === "/bss/refreshToken" && err.response) {
      console.log(err, "ERORR");
      if (
        err.response.status === 0 ||
        err.response.status === 401 ||
        err.response.status === 400
      ) {
        authService.logout();
        window.location.href = "/";
      }
    }

    return Promise.reject(err);
  }
);

export function getRequestInPricing(URL) {
  return axiosClient.get(`/${URL}`).then((response) => response.data);
}


export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response.data);
}
